import src from "IMAGE";
export default { src, width: 94, height: 94, blurWidth: 0, blurHeight: 0};
